import { render, staticRenderFns } from "./TeacherMessages.vue?vue&type=template&id=00b58554&"
import script from "./TeacherMessages.vue?vue&type=script&lang=js&"
export * from "./TeacherMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports